// cache.service.ts
import { inject, Injectable } from '@angular/core';
import { IndexDbStorageService } from './index-db.storage.service';

@Injectable({ providedIn: 'root' })
export class CacheService {
  constructor() {}
  private readonly indexDbStorageService = inject(IndexDbStorageService);

  async set(key: string, data: any, ttlMinutes: number): Promise<void> {
    const record = {
      value: data,
      expiry: new Date().getTime() + ttlMinutes * 60 * 1000,
    };
    await this.indexDbStorageService.setItem(key, JSON.stringify(record));
  }

  async get<T>(key: string): Promise<T | null> {
    // Fetch the record from IndexedDB using the storage service
    const record: string | null = await this.indexDbStorageService.getItem(key);

    // If there's no record, return null
    if (!record) return null;

    try {
      // Attempt to parse the record as JSON
      const parsed = JSON.parse(record);

      // Check if the record has expired (assuming "expiry" is a timestamp)
      if (parsed.expiry && new Date().getTime() > parsed.expiry) {
        // If expired, remove the item and return null
        await this.indexDbStorageService.removeItem(key);
        return null;
      }

      // Return the stored value (with correct typing)
      return parsed.value as T;
    } catch (error) {
      // Handle any errors during parsing (e.g., invalid JSON)
      await this.indexDbStorageService.removeItem(key); // Clean up the invalid record
      return null;
    }
  }

  async clear(key: string): Promise<void> {
    await this.indexDbStorageService.removeItem(key);
  }
}
